<template>
  <div
    class="search-results"
  >
    <NorticTabs
      :selected-index.sync="selectedTabIndex"
      @tab-change="handleTabChange"
    >
      <NorticTab
        v-for="tab in tabs"
        :key="tab.title"
        :title="tab.title"
        :badge="tab.badge"
      />
    </NorticTabs>

    <div
      v-if="selectedTabIndex === 0"
      class="results-list"
    >
      <OmniSearchEventResult
        v-for="(event, index) in searchResults.events"
        :key="index"
        :event="event"
        class="result"
      />

      <div
        v-if="!searchResults.events.length"
        class="no-search-results"
      >
        <h2>Tyvärr, hittade inga matchande evenemang</h2>
        <img src="@/assets/images/background/not_found.svg">
      </div>
    </div>

    <div
      v-else-if="selectedTabIndex === 1"
      class="results-list"
    >
      <OmniSearchModuleResult
        v-for="result in searchResults.modules"
        :key="result.key"
        :route="getRouterPath(result.key)"
        :result="result"
      />

      <div
        v-if="!searchResults.modules.length"
        class="no-search-results"
      >
        <h2>Tyvärr, hittade inga matchande appar</h2>
        <img src="@/assets/images/background/not_found.svg">
      </div>
    </div>
  </div>
</template>

<script>
import routerUtils from '@/components/common/mixins/routerUtils';
import OmniSearchModuleResult from '@/components/layout/navigation/menu/omnisearch/results/module/OmniSearchModuleResult.vue';
import OmniSearchEventResult from '@/components/layout/navigation/menu/omnisearch/results/event/OmniSearchEventResult.vue';
import NorticTabs from '@/components/common/navigation/tabs/NorticTabs.vue';
import NorticTab from '@/components/common/navigation/tabs/NorticTab.vue';

export default {
  name: 'OmniSearchResults',
  components: {
    NorticTab,
    NorticTabs,
    OmniSearchEventResult,
    OmniSearchModuleResult,
  },
  mixins: [routerUtils],
  props: {
    searchResults: {
      type: Object,
      default: () => {},
    },
    selectedTabIndex: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    tabs() {
      return [
        {
          title: 'Evenemang',
          badge: {
            themeType: 'contrast',
            value: this.searchResults.events.length,
          },
        },
        {
          title: 'Appar',
          badge: {
            themeType: 'contrast',
            value: this.searchResults.modules.length,
          },
        },
      ];
    },
  },
  methods: {
    handleTabChange(e) {
      this.$emit('update:selectedTabIndex', e.index);
    },
  },
};
</script>

<style lang="scss" scoped>
  .search-results {
    $sidePadding: 1em;

    .no-search-results {
      text-align: center;

      img {
        width: 100%;
      }
    }

    .label {
      margin-top: 50px;
      margin-bottom: 25px;
      position: relative;
      left: 15px;
    }

    .results-list {
      &:first-of-type {
        label {
          margin-top: 0;
        }
      }

      padding: 1em $sidePadding;
      display: grid;
      grid-auto-rows: auto;
      grid-gap: 1em;
    }
  }
</style>
